import React from 'react';

import ContactsContainer from '@totem/components/settings/sections/contacts/contactsContainer';
import ContactsHeaderActions from '@totem/components/settings/sections/contacts/contactsHeaderActions';
import ContactsTable from '@totem/components/settings/sections/contacts/contactsTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

import './contacts.css';

const Contacts = () => {
  return (
    <ContactsContainer>
      <IBCard isCovered title={'Contacts'} extra={<ContactsHeaderActions />}>
        <ContactsTable />
      </IBCard>
    </ContactsContainer>
  );
};

export default Contacts;
